<template>
  <div>
    <div class="section-head">转盘奖池设置</div>
    <el-table :data="tiers" border size="mini" class="tier-table">
      <el-table-column label="格子" width="56" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="奖励" min-width="200">
        <template slot-scope="scope">
          <div class="tier-reward-cell">
            <el-select
              v-model="scope.row.bonus_type"
              placeholder="选择奖励类型"
              size="mini"
              style="width: 100px"
              @change="onTierTypeChange(scope.$index)"
            >
              <el-option label="无奖励" :value="BONUS_NONE" />
              <el-option label="金币" :value="BONUS_GOLD" />
            </el-select>
            <template v-if="scope.row.bonus_type === BONUS_GOLD">
              <span class="currency-prefix"></span>
              <el-input-number
                style="width: 80px"
                v-model="scope.row.reward_count_yuan"
                :min="0"
                :precision="2"
                :controls="false"
                size="mini"
                class="tier-gold-input"
              />
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="库存" width="170">
        <template slot-scope="scope">
          <div class="tier-stock-line">
            <el-checkbox v-model="scope.row.total_unlimited" size="mini">不限</el-checkbox>
            <el-input-number
              :disabled="scope.row.total_unlimited"
              v-model="scope.row.available_num"
              :min="0"
              :precision="0"
              :controls="false"
              size="mini"
              class="tier-stock-input"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="已发放" width="72" align="center">
        <template slot-scope="scope">{{ scope.row.settled_count }}</template>
      </el-table-column>
      <el-table-column label="稽核倍数" width="110">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.multiple"
            :min="0"
            :precision="2"
            :controls="false"
            size="mini"
            :disabled="scope.row.bonus_type !== BONUS_GOLD"
            style="width: 100%"
          />
        </template>
      </el-table-column>
      <el-table-column label="概率权重" width="110">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.weight"
            :min="0"
            :precision="0"
            :controls="false"
            size="mini"
            style="width: 100%"
            :disabled="isTierOutOfStock(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="综合概率" width="100" align="center">
        <template slot-scope="scope">{{ tierProbTexts[scope.$index] }}</template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const BONUS_GOLD = 1
const BONUS_NONE = -1

const props = defineProps({
  tiers: {
    type: Array,
    required: true,
  },
})

function parseTierWeight(w) {
  const n = Number(w)
  return Number.isFinite(n) && n > 0 ? n : 0
}

function isTierOutOfStock(tier) {
  if (!tier) return false
  if (tier.total_unlimited) return false
  const available = Number(tier.available_num)
  return !Number.isFinite(available) || available <= 0
}

const tierProbTexts = computed(() => {
  const localTiers = props.tiers || []
  const weights = localTiers.map(t => (isTierOutOfStock(t) ? 0 : parseTierWeight(t.weight)))
  const sum = weights.reduce((a, b) => a + b, 0)
  if (sum <= 0) {
    return localTiers.map(() => '0%')
  }
  return weights.map(w => (w > 0 ? `${((w / sum) * 100).toFixed(2)}%` : '0%'))
})

function onTierTypeChange(index) {
  const row = props.tiers[index]
  if (!row) return
  if (row.bonus_type === BONUS_NONE) {
    row.reward_count_yuan = undefined
    row.multiple = 0
  } else if (row.bonus_type === BONUS_GOLD) {
    if (row.multiple == null || row.multiple === 0) {
      row.multiple = 1
    }
  }
}
</script>

<style lang="scss" scoped>
.section-head {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin: 16px 0 12px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  line-height: 1.2;
}

.tier-table {
  width: 100%;
  margin-bottom: 8px;
}

.tier-reward-cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.currency-prefix {
  color: #606266;
  font-size: 13px;
}

.tier-gold-input {
  width: 120px;
}

.tier-stock-input {
  width: 86px;
}

.tier-stock-line {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
</style>
